<div class="d-flex d-inline align-items-center">
  {{ name() }}
</div>
